import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../landingComponents/Navbar";
import Footer from "../landingComponents/Footer";
import Spinner from "../helperComponents/Spinner";
import { BaseUrl } from "../Services/Api";
import Swal from "sweetalert2";

const PrivateRoute = () => {
  const [isAuth, setIsAuth] = useState(null);
  const [redirecting, setRedirecting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${BaseUrl}/me`, {
          method: "GET",
          credentials: "include",
        });


        if (res.ok) {
          const data = await res.json();
          // console.log(data);
          setIsAuth(true);
        } else {
          setIsAuth(false);
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setIsAuth(false);
      }
    };

    checkAuth();
  }, []);

  // 🔹 Show alert and redirect if not authenticated
  useEffect(() => {
    if (isAuth === false && !redirecting) {
      setRedirecting(true);
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "You need to log in to access this page.",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
        allowOutsideClick: false,
      }).then(() => {
        navigate("/login", { replace: true });
      });
    }
  }, [isAuth, navigate, redirecting]);

  // 🔹 While checking authentication
  if (isAuth === null || redirecting) {
    return (
      <>
        <Navbar />
        <Spinner />
        <Footer />
      </>
    );
  }

  // 🔹 If authenticated, render nested routes via Outlet
  if (isAuth === true) {
    return <Outlet />;
  }

  return null;
};

export default PrivateRoute;
